import { MembershipTier } from 'types/SignUpData';

// Tier format is now unified: 'Tier 1' / 'Tier 2' / 'Tier 3' everywhere.
// These functions are kept as pass-throughs for call-site compatibility.
export const toBackendTier = (tier?: MembershipTier | string): string | undefined => {
  return tier || undefined;
};

export const fromBackendTier = (tier?: string): MembershipTier | undefined => {
  if (tier === 'Tier 1' || tier === 'Tier 2' || tier === 'Tier 3') return tier;
  return undefined;
};

// Helper function to normalize ORCID iDs from full URLs stored in event details
export const normalizeOrcidId = (orcid?: string): string | undefined => {
  if (!orcid) return undefined;
  return orcid.replace(/^https?:\/\/orcid\.org\//i, '');
};

// Helper function to normalize ORCID ID to full URL
export const orcidToUrl = (orcid?: string): string | undefined => {
  if (!orcid) return undefined;
  if (/^https?:\/\//i.test(orcid)) return orcid;
  return `https://orcid.org/${orcid}`;
};